import { render } from "./MenuContentItemTableCellInputInputGroupUpDownBoxSelect.vue?vue&type=template&id=0f15f1c8"
import script from "./MenuContentItemTableCellInputInputGroupUpDownBoxSelect.vue?vue&type=script&lang=js"
export * from "./MenuContentItemTableCellInputInputGroupUpDownBoxSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__